import React, { useState } from "react";
import Header from "../../Layout/Header";
import Footer from "../../Layout/Footer";
import AddIcon from '../../../images/add-icon.png';
import Patient1 from '../../../images/patient1.png';
import Patient2 from '../../../images/patient2.png';
import Patient3 from '../../../images/patient3.png';
import Patient4 from '../../../images/patient4.png';
import Patient5 from '../../../images/patient5.png';
import Consultation from '../../../images/consultation.png';
import Consultation1 from '../../../images/consultation1.png';
import PatientHeader from "../../Layout/PatientHeader";
import { Row, MobRow } from '../../utils/DashTableRow';
import { Link } from "react-router-dom";

const MyDashboard = () => {
  const [height, setHeight] = useState(0);

  const Schedule = ({bg, value, name}) => (
    <div className="schedule">
      <span style={{ backgroundColor:bg }} className="dashboardCircle mb-3">{value}</span>
      <span className="dashboardCircleTitle">{name} <br /> Appointment</span>
    </div>
  )

  return (
    <div>
      <Header setHeight={setHeight} />
      <div
        className="profile_crumb"
        style={{ height: height + 10 + "px" }}
      ></div>
      <div className="pb-5">
        <section className="pt-5 pb-1">
          <PatientHeader title="My Dashboard" />
          <div className="container">
            <div className="px-5 pt-1 pb-5">
              <div className="row myDashboardTop">
                <Schedule bg="#E91E63" value="16" name="Today's" />
                 <Schedule bg="#9C27B0" value="150" name="This Week's" />
                 <Schedule bg="#2196F3" value="400" name="This Months's" />
                 <Schedule bg="#4CAF50" value="80" name="Completed" />
              </div>
            </div>
          </div>
          <div className="myDashboard pt-5">
            <div className="container ">
              <div className="row py-1 px-3">
                <div className="myDashboardTitle">
                  <h2 className="font-weight-bold py-4">My Appointments</h2>
                  <Link to="/doctor/mydashboard/add" className="hide_on_med btn font-weight-bold btn-theme text-uppercase font-smaller py-2 px-3 btn-dark">
                    <img src={AddIcon} alt="Add Icon" />create an appointment</Link>
                  <Link to="/doctor/mydashboard/add" className="hide_on_large btn btn-theme text-uppercase font-smaller py-2 px-3 btn-dark">
                    <img src={AddIcon} alt="Add Icon" /></Link>
                </div>
              </div>
              <div className="row pt-1 pb-5 px-3">
                {/* For Desktop */}
                <div className="cus_table hide_on_med">
                  <table className="table ">
                    <tbody>
                      <tr className="cus_head">
                        <td>No.</td>
                        <td>Patient Name</td>
                        <td>Date</td>
                        <td>Time</td>
                        <td>Consultation</td>
                        <td>Action</td>
                      </tr>
                      <Row no="1" src={Patient1} name="John Doe" phone="+880 123 4567" date="16 NOV 2020" time="18:30 - 19:00" conSrc={Consultation} />
                      <Row no="2" src={Patient2} name="Walten Alejo" phone="+880 123 4567" date="16 NOV 2020" time="18:30 - 19:00" conSrc={Consultation} />
                      <Row no="3" src={Patient3} name="Jane Doe" phone="+880 123 4567" date="16 NOV 2020" time="18:30 - 19:00" conSrc={Consultation1} />
                      <Row no="4" src={Patient4} name="Caleveland" phone="+880 123 4567" date="16 NOV 2020" time="18:30 - 19:00" conSrc={Consultation} />
                      <Row no="5" src={Patient5} name="Baryan Dinkins" phone="+880 123 4567" date="16 NOV 2020" time="18:30 - 19:00" conSrc={Consultation1} />
                    </tbody>
                  </table>
                </div>
                {/* For Mobile */}
                <div className="cus_table_mob hide_on_large">
                  <div className="col-lg-12">
                    <MobRow no="1" src={Patient1} name="John Doe" phone="+880 123 4567" date="16 NOV 2020" time="18:30 - 19:00" conSrc={Consultation} />
                    <MobRow no="2" src={Patient2} name="Walten Alejo" phone="+880 123 4567" date="16 NOV 2020" time="18:30 - 19:00" conSrc={Consultation} />
                    <MobRow no="3" src={Patient3} name="Jane Doe" phone="+880 123 4567" date="16 NOV 2020" time="18:30 - 19:00" conSrc={Consultation1} />
                    <MobRow no="4" src={Patient4} name="Caleveland Jawad" phone="+880 123 4567" date="16 NOV 2020" time="18:30 - 19:00" conSrc={Consultation} />
                    <MobRow no="5" src={Patient5} name="Baryan Dinkins" phone="+880 123 4567" date="16 NOV 2020" time="18:30 - 19:00" conSrc={Consultation1} />
                  </div>
                </div>
              </div>
              <center><button className="loadBtn px-3 py-2 my-5">Load More</button></center>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default MyDashboard;
